import React from "react";
import Teddy from '../Teddy.jpeg'; // Fixed the variable name to match the file name
import { PiHandsClapping } from "react-icons/pi";

function Middle() {
    return (
        <div className="middle">
            <div className="box-1">
                <div className="b-1">
                    <img src={Teddy} alt="Teddy" />
                </div>

                <div className="b-2">
                    <h1 className="font-syne">NFD platform</h1>
                    <h1 className="font-syne " style={{ color: "#848aff" }}>“NFD.gg”</h1>
                </div>

                <div className="b-3">
                    <div className="b-3-1 p-[10px] font-gothica1 font-[400]">An Alpha community 2.0 with its own platform for participating, searching, and tracking any crypto related information.</div>
                </div>

                <div className="b-4">
                    <button className="version-button w-[183px]" style={{ backgroundColor: "rgb(108, 82, 238)" }}>Try Platform</button>
                    <a href="/#">How it works?</a>
                </div>

            </div>

            <div className="box-2">

                <div className="b2-1">
                    <button className="button-1 rounded-full border-1" style={{ backgroundColor: 'transparent', borderColor: 'rgb(149, 128, 255)' }}>
                        <PiHandsClapping style={{ fontSize: '30px' }} /> Software by NFD
                    </button>
                </div>


                <div className="b-2">
                    <div className="font-syne">NFD software</div>
                    <h1 className="gradient-text font-syne ">“Combine”</h1>
                </div>

                <div className="b-3">
                    <div className="b-3-1 p-[10px] font-gothica1 font-[400] text-[18px]">Handle your crypto-wallets, farm activities and retrodrops on a single app.</div>
                </div>

                <div className="b-4">
                <button className="version-button w-[183px]" style={{ backgroundColor: "rgb(108, 82, 238)" }}>Download</button>
                    <a href="/#">How it works?</a>
                </div>


            </div>

        </div>
    )
}

export default Middle;
